export default __webpack_public_path__ + "static/media/status.de8a4f12.svg";